<template>
  <a-modal
    v-model:visible="visible"
    title="表盘内存信息"
    ok-text="关闭"
    :width="800"
    @ok="handleok"
  >
    <div>
      <WatchfaceRamTable @close="handleok" />
    </div>
    <template #footer>
      <a-button @click="handleok">关闭</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

// const appInfo = ref<AppInfo>();
// onMounted(async () => (appInfo.value = await ElectronApi.getAppInfo()));

const visible = ref<boolean>(false);
defineExpose({
  open: async () => {
    visible.value = true;
  }
});

const handleok = () => {
  visible.value = false;
};
</script>

<style scoped></style>
